import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Form from './Form';

class Edit extends Component {
  render() {
    const {
      isModalOpen,
      onCloseHandler,
      onSubmitHandler,
      error,
      submitting,
      vinBlacklist,
    } = this.props;

    return (
      <Form
        isModalOpen={isModalOpen}
        onCloseHandler={onCloseHandler}
        onSubmitHandler={onSubmitHandler}
        error={error}
        submitting={submitting}
        vinBlacklist={vinBlacklist}
        action='edit'
      />
    );
  }
}

Edit.propTypes = {
  isModalOpen: PropTypes.bool,
  onCloseHandler: PropTypes.func.isRequired,
  onSubmitHandler: PropTypes.func.isRequired,
  error: PropTypes.string,
  submitting: PropTypes.bool,
  vinBlacklist: PropTypes.shape({
    id: PropTypes.number,
    expirationDate: PropTypes.string,
    vin: PropTypes.string,
    notes: PropTypes.string,
  }),
};

Edit.defaultProps = {
  isModalOpen: false,
  error: null,
  submitting: false,
  vinBlacklist: {},
};

export default Edit;
